
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import Usuarios from '@/components/usuarios/TheUsuarios'
import TheAgendamentos from '@/components/usuarios/TheAgendamentos'
import Solicitacoes from '@/components/solicitacoes/Solicitacoes'
import Pontos from '@/components/pontos/MeuPonto'
import CargaHoraria from '@/components/cargahoraria/CargaHoraria'
import AreaReservada from '@/components/secret/AreaReservada'

import Relatorios from '@/components/relatorios/Relatorios'
import ChatMessage from '@/components/chat/ChatMessage'
import Auth from '@/components/Auth'
import RecoverPass from '@/components/RecoverPass'
import NewPassword from '@/components/NewPassword'
import Configuracoes from '@/components/configuracoes/Configuracoes'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [{
	name: 'auth',
	path:'/auth',
	component: Auth
},{
	name:'home',
	path:'/',
	component: Home,
	meta:{requiresAdmin:true}
},{
	name:'usuarios',
	path:'/usuarios',
	component: Usuarios,
	meta:{ requiresAdmin: true }
},{
	name:'pontos',
	path:'/pontos',
	component: Pontos
},{
	name:'cargahoraria',
	path:'/carga',
	component: CargaHoraria,
	meta:{ requiresAdmin: true }
},
{
	name:'bancohoras',
	path:'/bancohoras',
	redirect: { name: 'relatorios', query: { tab: 'banco-horas' } },
	meta:{ requiresAdmin: true }
},
{
	name:'areaReservada',
	path:'/area-reservada',
	component: AreaReservada,
	meta:{ requiresAreaReservada: true }
},

{
	name: 'recover',
	path: '/recover',
	component: RecoverPass
},
{
	name: 'newpassword',
	path: '/newpassword/:token',
	component: NewPassword
},
{
	name: 'agendamentos',
	path: '/agendamentos',
	component: TheAgendamentos
},
{
	name: 'solicitacoes',
	path: '/solicitacoes',
	component: Solicitacoes
},
{
	name: 'chat',
	path: '/chat',
	component: ChatMessage
},
{
	name: 'configuracoes',
	path: '/configuracoes',
	component: Configuracoes,
	meta:{ requiresAdmin: true }
},
{
	name: 'relatorios',
	path: '/relatorios',
	component: Relatorios,
	meta:{ requiresAdmin: true }
}]


const router = new VueRouter({
	mode: 'history',
	routes
})
router.beforeEach((to, from, next) => {
	const json = localStorage.getItem(userKey)
	const isAuthenticated = !!json
	const user = isAuthenticated ? JSON.parse(json) : null
	const tipo = String(user?.tipo || '').trim().toLowerCase()
	const perfisGestao = ['gerente', 'admin', 'master', 'supervisor', 'financeiro', 'coordenador']

    // 1. Redireciona usuário autenticado ao home ao acessar login
	if (to.name === 'auth' && isAuthenticated) {
		return next({ name: 'home' })
	}


	if (to.matched.some(record => record.meta.requiresAdmin)) {
		if (user && perfisGestao.includes(tipo)) {
			return next()
		} else {
			return next({ path: '/pontos' })
		}
	} 
	// 3. Permite acesso à redefinição de senha com token
	if (to.matched.some(record => record.meta.requiresAreaReservada)) {
		const idFuncionario = Number(user?.idfuncionario || 0)
		if (user && (tipo === 'master' || idFuncionario === 14)) {
			return next()
		}
		return next({ path: '/pontos' })
	}

	if (to.name === 'newpassword') {
		const token = to.params.token || to.query.token
		if (token) {
			return next()
		} else {
			return next({ path: '/' })
		}
	}
	
	next()

})
export default router
